import React, { useEffect, useState } from "react";
import { Row, Col, Form, Alert } from "react-bootstrap";
import axiosClient from "../../../../config/axios";
import moment from "moment-timezone";

function InfringementData({ values, setFieldValue, errors }) {
  const [serviceTypes, setServiceTypes] = useState([]);
  const [tiempoTranscurrido, setTiempoTranscurrido] = useState(null);
  const [loading, setLoading] = useState(false);

  const getLocalDateTimeNow = () => {
    return moment
      .tz("America/Mexico_City")
      .seconds(0)
      .milliseconds(0)
      .format("YYYY-MM-DDTHH:mm");
  };

  useEffect(() => {
    setLoading(true);
    axiosClient
      .get("/typeServices/datatable")
      .then((response) => {
        const options = response.data.data.map((item) => ({
          value: item.id,
          label: item.type_service_name,
        }));
        setServiceTypes(options);
      })
      .catch((error) => {
        console.error("Error al obtener tipos de servicio:", error);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (values.fecha_hora_orden) {
      const fechaOrden = moment.tz(
        values.fecha_hora_orden,
        "America/Mexico_City"
      );
      const ahora = moment.tz("America/Mexico_City");

      const duracion = moment.duration(ahora.diff(fechaOrden));
      const dias = Math.floor(duracion.asDays());
      const horas = duracion.hours();

      setTiempoTranscurrido({ dias, horas });
    } else {
      setTiempoTranscurrido(null);
    }
  }, [values.fecha_hora_orden]);

  useEffect(() => {
    // Solo obtener la última fecha si el campo está vacío
    if (!values.fecha_hora_orden) {
      axiosClient
        .get(
          "/order-vial/datatable?draw=1&start=0&length=1&search=&sort=id&dir=desc"
        )
        .then((response) => {
          const ultimaOrden = response.data.data?.[0];
          if (ultimaOrden?.fecha_hora_orden) {
            const fecha = moment
              .utc(ultimaOrden.fecha_hora_orden)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm");

            setFieldValue("fecha_hora_orden", fecha);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la última orden:", error);
        });
    }
  }, []);

  return (
    <Row className="mb-3">
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Folio</Form.Label>
          <Form.Control
            type="text"
            name="folio"
            placeholder="Folio"
            value={values.folio}
            onChange={(e) => setFieldValue("folio", e.target.value)}
            isInvalid={!!errors.folio}
          />
          <Form.Control.Feedback type="invalid">
            {errors.folio}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Número de expediente</Form.Label>
          <Form.Control
            type="text"
            name="expedienteNo"
            placeholder="Número de expediente"
            value={values.expedienteNo}
            onChange={(e) => setFieldValue("expedienteNo", e.target.value)}
            isInvalid={!!errors.expedienteNo}
          />
          <Form.Control.Feedback type="invalid">
            {errors.expedienteNo}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Número de infracción</Form.Label>
          <Form.Control
            type="text"
            name="infraccionNo"
            placeholder="Número de infracción"
            value={values.infraccionNo}
            onChange={(e) => setFieldValue("infraccionNo", e.target.value)}
            isInvalid={!!errors.infraccionNo}
          />
          <Form.Control.Feedback type="invalid">
            {errors.infraccionNo}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Motivo de la infracción</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="motivoInfraccion"
            placeholder="Motivo de la infracción"
            value={values.motivoInfraccion}
            onChange={(e) => setFieldValue("motivoInfraccion", e.target.value)}
            isInvalid={!!errors.motivoInfraccion}
          />
          <Form.Control.Feedback type="invalid">
            {errors.motivoInfraccion}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Fecha y hora de reporte</Form.Label>
          <Form.Control
            type="datetime-local"
            name="fecha_hora_orden"
            value={values.fecha_hora_orden}
            max={getLocalDateTimeNow()}
            onChange={(e) => setFieldValue("fecha_hora_orden", e.target.value)}
            isInvalid={!!errors.fecha_hora_orden}
          />
          <Form.Control.Feedback type="invalid">
            {errors.fecha_hora_orden}
          </Form.Control.Feedback>
        </Form.Group>

        {tiempoTranscurrido && (
          <Alert variant={tiempoTranscurrido.dias > 0 ? "warning" : "info"}>
            {tiempoTranscurrido.dias === 0 && tiempoTranscurrido.horas === 0
              ? "La orden fue registrada hace menos de una hora."
              : `Han pasado ${tiempoTranscurrido.dias} día(s) y ${tiempoTranscurrido.horas} hora(s) desde la fecha de la orden.`}
          </Alert>
        )}

        {/* Select de tipo de servicio */}
        <Form.Group className="mb-3">
          <Form.Label>Tipo de servicio</Form.Label>

          {loading ? (
            <div className="text-center my-4">
              <i className="fa fa-spinner fa-spin fa-3x"></i>
              <p>Cargando...</p>
            </div>
          ) : (
            <Form.Select
              name="tipoServicio"
              value={values.tipoServicio}
              onChange={(e) =>
                setFieldValue("tipoServicio", parseInt(e.target.value))
              }
              isInvalid={!!errors.tipoServicio}
            >
              <option value="">Selecciona una opción</option>
              {serviceTypes.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </Form.Select>
          )}

          <Form.Control.Feedback type="invalid">
            {errors.tipoServicio}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
    </Row>
  );
}

export default InfringementData;
